import apples from './apples.png';
import apple from './apple.png';
import grapes from './grapes.png';

export default {
	apples,
	apple,
	grapes
};
